package com.starparty.app.astro0

import com.starparty.app.geometry.SP_Rectangle

abstract class SP_Paint {

    public var currentColour = SP_Colour(0,0,0,0)
    public var currentTextSize = 10.0f
    public var currentFont = "sans-serif"
    public var lineWidth = 1.0

    abstract fun setColour(c: SP_Colour)

    open fun setTextSize(size:Float) {
        currentTextSize = size
    }

    fun getCSSRGBAColorString():String {
        val r = currentColour.r
        val g = currentColour.g
        val b = currentColour.b
        val a = currentColour.a / 255.0
        return "rgba($r, $g, $b, $a)"
    }

    abstract fun getTextBounds(string: String): SP_Rectangle

    fun getFontString(): String{
        return "${currentTextSize}px $currentFont"
    }
}